if ($(".search__icon").length) {
  $(".search__icon").click(function () {
    setTimeout(function () {
      $(".wz-input").click();
      $(".wz-input").focus();
    }, 200);
  });
}
window.onWizzyScriptLoaded = function () {
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-common-select");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        var attributues = product.attributes;
        attributues.forEach((attribute) => {
          if (attribute.id == "product_bstr-tag_tags") {
            product.wzTags = attribute.valuesAll;
          }

          if (attribute.id == "product_subtitle_global") {
            product.wzSubTitles = Array.isArray(attribute.valuesAll)
              ? attribute.valuesAll.map((subTitle) =>
                  typeof subTitle === "string"
                    ? subTitle
                        .replace(/<\/?p>/g, "")
                        .replace(/&nbsp;/g, " ")
                        .replace(/&amp;/g, "&")
                    : subTitle
                )
              : [];
          }

          if (attribute.id == "product_badge_judgeme") {
            let reviewHtml = attribute.valuesAll;

            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = reviewHtml;

            let badgeElement = tempDiv.querySelector(".jdgm-prev-badge");

            let rating =
              badgeElement && badgeElement.getAttribute("data-average-rating")
                ? parseFloat(
                    badgeElement.getAttribute("data-average-rating")
                  ).toFixed(1)
                : "";

            let reviews =
              badgeElement &&
              badgeElement.getAttribute("data-number-of-reviews")
                ? badgeElement.getAttribute("data-number-of-reviews")
                : "";

            let reviewData = `⭐ ${rating} | ✅ ${reviews} reviews`;
            product.reviewData = reviewData;
            product.rating = rating;
          }
        });
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      var closeIcon = $(".uil.uil-multiply");
      $(closeIcon).click();
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.sort.forEach((opt) => {
        if (opt.field == "sellingPrice") {
          data.filters.showOOSProductsInOrder = "true";
        }
      });
      return data;
    }
  ),
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (payload) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
          ".wz-child-main";
        payload.filters = {
          configs: {
            keepOpenedInMobileAfterApply: 1,
          },
        };
        return payload;
      }
    );
   window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
      function (data) {
        if (data.api === "search") {
          const totalCount = data?.response?.payload?.total;
          const query = data?.response?.payload?.filters?.q;
          if (typeof totalCount === "number" && query ) {
              webengage.track("Searched Product" , {
              "Source" : "Shopify",
              "Terms" : query,
              "Total Items" : totalCount
            })
          }          
        }
        return data;
      }
    );
};

const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
